import sectionHtmlTemplate from "./SectionPage.ejs"
import sectionsMapMenu from "../../components/SectionsMapMenu/SectionsMapMenu";
import sectionsMapView from "../../components/SectionsMapView/SectionsMapView";
import makeTemplateFunc from "lodash/template"
import { Preloader, housingNav } from "../../components"
import { SECTION_PAGE, FLOOR_PAGE, FLOOR_SELECTED_FLAT_PAGE, FLAT_PAGE } from "../../routes"
import {
    getSection,
    registerPreloader
} from "../../api"
import $ from "jquery";
import "../../components/CallbackPopup/CallbackPopup";

const sectionTemplateFunc = makeTemplateFunc(sectionHtmlTemplate);

export class SectionPage {
    constructor($container, params, app) {
        this.$container = $container;
        this.params = params;
        this.app = app;
        registerPreloader(new Preloader(this.$container))
    }

    render() {
        getSection(this.app.apiPaths.SECTION_DETAIL, this.params).then((response) => this.renderPage(response))
    }

    renderPage(response) {
        this.$container.addClass('h100');
        this.$container.html(sectionTemplateFunc({response}));
        sectionsMapMenu.render(this.$container.find('.js-sections-map-menu'), response);
        sectionsMapView.render(this.$container.find('.js-sections-map-view'), response);

        this.$container.find('.js-get-flat').on('click', this.app.handleSectionFlatClick.bind(this));
        this.$container.find('.js-get-floor').on('click', this.app.handleFloorClick.bind(this));
        this.$container.find('.js-section-field').on('click', this.app.handleSectionClick.bind(this));
        this.$container.find('.js-get-section').on('click', this.app.handleSectionClick.bind(this));

        $('.js-scrolling').mCustomScrollbar({
            axis: 'y',
            scrollInertia: 500,
            scrollbarPosition: 'inside',
            theme: "minimal-dark",
            mouseWheel: {
                enable: true,
                scrollAmount: 200
            }
        });

        $(window).resize();

        housingNav.actualize(response.responseJSON.prevHousing, response.responseJSON.nextHousing);

        if ($(window).width() > 768) {
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover focus',
                template: '<div class="tooltip tooltip-new" role="tooltip" style="position: absolute;"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
                title: 'Уточните цену в офисе',
                placement: 'top',
                html: true,
                delay: {show: 100, hide: 200}
            });
        }

        this.app.initScroll();
    }
}



// WEBPACK FOOTER //
// ./js/pages/SectionPage/SectionPage.js